import { createContext, useContext, useState } from "react";

const ThemeContext = createContext(); // Create a Context for the theme

export const ThemeProvider = ({ children }) => {
  // Create a provider component , and send children props
  const [theme, setTheme] = useState("light"); // when the app loads, default to light theme

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light")); // if the setTheme already light change to dark, else change to light
  };
  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
  //  return all the childeren components wrapped in the ThemeContext.Provider
};

export const useTheme = () => useContext(ThemeContext); // open for use in other components to consume the theme context
